// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentMethodOption_container__2H9_w","providerLogo":"PaymentMethodOption_providerLogo__1UwcL"};